import React, { Component } from "react";

import "./Tabs.less";

export default class Tabs extends Component {
  render() {
    const style = {
      ...this.props.style,
      width: this.props.width,
    };
    return (
      <div
        className={"nano-panel-tabs " + (this.props.className || "")}
        style={style}
      >
        {this.props.children}
      </div>
    );
  };
}
